import { IGameAttendances } from "./IGameAttendances";
import { IPlayersGroupGames } from "./IPlayersGroupGames";
import { GameType } from "../../../src/screens/new-game/NewGame.types";

export enum GameStatues {
  SCHEDULED = "SCHEDULED",
  CONFIRMED = "CONFIRMED",
  CANCELED = "CANCELED",
  FINISHED = "FINISHED",
  FINALIZED = "FINALIZED",
}

export const GameStatusFlow: { [key in GameStatues]: GameStatues[] } = {
  [GameStatues.SCHEDULED]: [GameStatues.CONFIRMED, GameStatues.CANCELED],
  [GameStatues.CONFIRMED]: [GameStatues.SCHEDULED, GameStatues.FINISHED, GameStatues.CANCELED],
  [GameStatues.FINISHED]: [GameStatues.CONFIRMED, GameStatues.FINALIZED],
  [GameStatues.FINALIZED]: [GameStatues.FINISHED],
  [GameStatues.CANCELED]: [GameStatues.SCHEDULED, GameStatues.CONFIRMED],
};

export interface IGame {
  created_at: string;
  datetime: string | null;
  group_id: number | null;
  host_score: number | null;
  id: number;
  location: string | null;
  notes: string | null;
  status: GameStatues;
  visitor_score: number | null;
  game_type: GameType;
  group: {
    id: number;
    name: string;
    created_at: string;
    group_logo: string | null;
  };
  attendees: IGameAttendances[];
  host_team_name: string;
  visitor_team_name: string;
  playing_as_host: boolean;
  season_id: number | null;
  season_information: string | null;
  organization_logo: string | null;
  host_team_logo: string | null;
  visitor_team_logo: string | null;
  host_group_id: number | null;
  visitor_group_id: number | null;
  // why game prop inside game interface?
  // game: IPlayersGroupGames[] | null;
}

export const GameTeams = {
  hosts: {
    key: "HOST",
    label: "Beli",
  },
  visitors: {
    key: "VISITOR",
    label: "Markeri",
  },
};
